import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import _ from "lodash";
import 'video.js/dist/video-js.css';
import videojs from "video.js";
import Tooltip from "../../../../components/Tooltip";

class Video extends Component {

  constructor(props) {
    super(props);

    if (props.details.length === 0)
      props.onDetailsUpdated([{watched: false}])
  }

  componentDidMount() {
    const {question, startTime} = this.props;
    this.player = videojs(this.videoNode, this.props, () => {
    });
    const screenWidth = document.getElementById(question.id + "-video-container").offsetWidth;
    const isMobile = screenWidth < question.playerWidth;
    this.player.fluid(isMobile)
    this.player.width(question.playerWidth)
    this.player.height(question.playerHeight)
    this.player.autoplay(question.autoPlay)
    if (question.required) {
      this.player.controlBar.progressControl.hide();
    }
    setInterval(() => {
      const screenWidth = document.getElementById(question.id + "-video-container").offsetWidth;
      const isMobile = screenWidth < question.playerWidth;
      this.player.fluid(isMobile)
    }, 1000)
    this.player.on("ended", () => {
      const microTime = getCurrentMicroTime(startTime);
      this.props.onDetailsUpdated([{
        watched: true,
        microTime
      }]);

      if (question.autoNextPage)
        this.props.changePage(1);
    })
  }

  // Dispose the player when the component will unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  validate() {
    const {validationTexts, details} = this.props;
    const {required} = this.props.question;

    let validate =  {
      valid: true,
      errors: []
    };

    if (required && (_.isEmpty(details) || !details[0].watched)) {
      validate.errors.push(validationTexts.required);
    }

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render() {
    const {question} = this.props;
    let type;
    if (question.video.toLowerCase().endsWith('webm')) {
      type = 'video/webm';
    } else {
      type = "video/" + (question.video ? question.video.substr(question.video.length - 3) : 'mp4')
    }

    return (
      <div style={{textAlign: "center"}} className="mx-auto pb-2" id={question.id + "-video-container"}>
        <div className="text-right">
          <i id={`q-${question.id}-video-info`} className="fas fa-info-circle ml-auto" />
          <Tooltip id={`q-${question.id}-video-info`} msg={'<div class="text-left">Jeśli nagranie się nie odtwarza.<br /><br />' +
          'Możliwe przyczyny:<br />' +
          '1/ Wolne lub niestabilne łącze internetowe. Kontynuuj wypełnianie ankiety na szybszym łączu<br />' +
          '2/ Korzystasz z VPN lub wypełniasz ankietę w pracy. Kontynuuj wypełnianie ankiety w domu lub udostepnij internet z Twojego telefonu<br />' +
          '3/ Problem po stronie serwera. Odśwież ankietę (CTRL+R)<br />' +
          '4/ Problem po stronie przeglądarki. Wypełnij ankietę na aktualnej wersji przeglądarek: Chrome, Firefox, Opera, Safari, Edge. Wypełnij ankietę w trybie prywatnym / incognito.</div>'} />
        </div>
        <div data-vjs-player>
          <video ref={node => this.videoNode = node} data-setup='{"controls": true, "preload": "auto"}' className="video-js">
            <source src={question.video} type={type}/>
          </video>
        </div>
      </div>
    )
  }
}

Video.propTypes = {
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    watched: PropTypes.bool.isRequired,
    microTime: PropTypes.number,
  }).isRequired),
  changePage: PropTypes.func.isRequired,
  question: PropTypes.shape({
    video: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    autoPlay: PropTypes.bool.isRequired,
    autoNextPage: PropTypes.bool.isRequired,
    playerWidth: PropTypes.number.isRequired,
    playerHeight: PropTypes.number.isRequired,
  }).isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Video);